import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import SelectorHora from "../general/SelectorHora";

function NuevoBloqueo() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [agendas, setAgendas] = useState([]);

    const [descripcion, setDescripcion] = useState();
    const [agenda, setAgenda] = useState();
    const [nombreAgenda, setNombreAgenda] = useState();
    const [horaInicio, setHoraInicio] = useState();
    const [horaFin, setHoraFin] = useState();
    const [fechaInicio, setFechaInicio] = useState();
    const [fechaFin, setFechaFin] = useState();
    const [fechaFinRepeticion, setFechaFinRepeticion] = useState();
    const [frecuencia, setFrecuencia] = useState(0);

    const [showFechas, setShowFechas] = useState('hide');

    const [opcionesRepeticion, setOpcionesRepeticion] = useState([]);

    let history = useHistory();

    let userdata = [];
    let clientData = [];
    let rolePermissions = [];

    const [errorlist, setErrorlist] = useState({});

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        
        axios.get('/get-client?uid='+userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        // ✅ Cargar agendas usando axios - el backend obtiene client_id del token
        axios.get('/listado-agendas')
        .then(response => {
            setAgendas(response.data);
        })
        .catch(error => {
            console.error('Error cargando agendas:', error);
        });
    },[]);


    const asignarAgenda = (id, nombre) => {
        setAgenda(id);
        setNombreAgenda(nombre);
    };


    useEffect(() => {
        if (frecuencia!=0) {
            setShowFechas('');
        }
        else {
            setShowFechas('hide');
        }
    },[frecuencia]);


    useEffect(() => {
        setFechaFin(fechaInicio);
    },[fechaInicio]);

    useEffect(() => {
        if (fechaInicio==fechaFin) {
            setOpcionesRepeticion([ 
                { value: '', text: 'Nunca', visible: true },  
                { value: 'dias', text: 'Todos Los Días', visible: true },
                { value: 'semana', text: 'Cada Semana', visible: true },
                { value: 'mes', text: 'Cada Mes', visible: true }
            ]);
        }
        else {
            setOpcionesRepeticion([ 
                { value: '', text: 'Nunca', visible: true },  
                { value: 'dias', text: 'Todos Los Días', visible: false },
                { value: 'semana', text: 'Cada Semana', visible: true },
                { value: 'mes', text: 'Cada Mes', visible: true }
            ]);
        }
    },[fechaFin]);


    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Validar campos requeridos
        if (!descripcion || !agenda || !horaInicio || !horaFin || !fechaInicio || !fechaFin) {
            alert('Por favor complete todos los campos requeridos');
            return;
        }
        
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // ✅ Ya NO necesitas headers - el interceptor agrega el token automáticamente
        const conf = {
            id_client: client.client_id,
            descripcion: descripcion,
            id_agenda: agenda,
            hora_inicio: horaInicio,
            hora_fin: horaFin,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin,
            frecuencia: frecuencia || '',
            fecha_fin_repeticion: fechaFinRepeticion || null,
            fecha_hora_inicio: fechaInicio+" "+horaInicio, // SelectorHora ya incluye :00
            fecha_hora_fin: fechaFin+" "+horaFin // SelectorHora ya incluye :00
        };
         
        axios.post('/bloqueo', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg','Se Ha Creado Un Nuevo Bloqueo De Agenda Para '+nombreAgenda);
                    history.push('/bloqueos-agenda');
                }
            )
            .catch(
                err => {
                    console.error('Error guardando bloqueo:', err);
                    // Manejar errores de validación del backend
                    if (err.response && err.response.data && err.response.data.errors) {
                        setErrorlist(err.response.data.errors);
                    } else {
                        // Error genérico
                        alert('Error al guardar el bloqueo. Por favor, intente nuevamente.');
                    }
                    setLoading(false);
                }
            )
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-agenda">Parámetros de Agenda</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/bloqueos-agenda">Bloqueo De Horarios</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Bloqueo De Horarios</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Nuevo Bloqueo De Horarios</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-12">
                                    
                                    <form id="role-form" onSubmit={handleSubmit} autoComplete={'off'}>
                                        <div className="card">
                                            <div id="infobasica">
                                                <div className="card-body">
                                                    
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="descripcion">Descripción Del Bloqueo</label>
                                                                <input 
                                                                    type="text" 
                                                                    name="descripcion" 
                                                                    className="form-control" 
                                                                    id="descripcion" 
                                                                    onChange={(e) => setDescripcion(e.target.value)}
                                                                    required
                                                                    disabled={loading}
                                                                />
                                                                {errorlist && errorlist.descripcion && (
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.descripcion}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="agenda">Agenda A Bloquear</label>
                                                                <select name="agenda" className="form-control" id="agenda" 
                                                                    onChange={(e) => asignarAgenda(e.target.value, e.target.options[e.target.selectedIndex].text)}>
                                                                    <option></option>
                                                                    {agendas.map((agenda) => <option key={'ag'+agenda.id} value={agenda.id}>{agenda.nombre}</option>)}
                                                                </select>
                                                                <div className="invalid-feedback visible">
                                                                {errorlist.id_agenda}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="fechaInicio">Fecha Inicio</label>
                                                                <input type="date" name="fechaInicio" className="form-control" id="fechaInicio" onChange={(e) => setFechaInicio(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                {errorlist.fecha_inicio}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="horaInicio">Hora De Inicio</label>
                                                                <SelectorHora onChange={setHoraInicio} />
                                                                <div className="invalid-feedback visible">
                                                                {/*errorlist.hora_inicio*/}
                                                                {errorlist.fecha_hora_inicio}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="fechaFin">Fecha De Finalización</label>
                                                                <input type="date" name="fechaFin" className="form-control" id="fechaFin" defaultValue={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                {errorlist.fecha_fin}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="horaFin">Hora De Finalización</label>
                                                                <SelectorHora onChange={setHoraFin} />
                                                                <div className="invalid-feedback visible">
                                                                {/*errorlist.hora_fin*/}
                                                                {errorlist.fecha_hora_fin}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="fechaFin">Repetir Este Bloqueo:</label>
                                                                <select name="frecuencia" className="form-control" id="frecuencia" onChange={(e) => setFrecuencia(e.target.value)}>
                                                                    {
                                                                        opcionesRepeticion.map((opcion, index) => {
                                                                            return opcion.visible ? <option key={index} value={opcion.value}>{opcion.text}</option> : '';
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={'row '+showFechas}>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="fechaFinRepeticion">Fecha Fin Repetición</label>
                                                                <input type="date" name="fechaFinRepeticion" className="form-control" id="fechaFinRepeticion" onChange={(e) => setFechaFinRepeticion(e.target.value)} />
                                                                <div className="invalid-feedback visible">
                                                                {/*errorlist.fecha_fin_repeticion*/}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <Link to="/bloqueos-agenda" className="btn btn-secondary">
                                                Cancelar
                                            </Link>
                                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                                Crear Nuevo Bloqueo
                                                {loading && <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>}
                                            </button>
                                        </div>

                                    </form>

                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default NuevoBloqueo;